import React from "react";
import { useSearchParams } from "react-router-dom";
import { AddCartProps } from "../../carts/views/CartView";
import { HomePageLinkFilterModel, HomePageLinkType, SearchOption } from "../models/ProductModel";
import ProductView from "../views/users/ProductView";

const Product: React.FC<AddCartProps> = ({ addToCart }) => {
    const [searchParams] = useSearchParams();

    // Get specific query parameter
    const searchText = searchParams.get('searchText') ?? "";
    const key = searchParams.get('key') ?? "";
    const strType = searchParams.get('type');
    const strOption = searchParams.get('option');

    var type = HomePageLinkType.all;
    var option = SearchOption.contains;

    if (strType) {
        type = HomePageLinkType[strType as keyof typeof HomePageLinkType];
    }

    if (strOption) {
        option = SearchOption[strOption as keyof typeof SearchOption];
    }

    let model: HomePageLinkFilterModel = {
        type: type,
        option: option,
        key: key,
        search: searchText
    };

    return <div><ProductView linkToProductModel={model} addToCart={addToCart} /></div>;
};

export default Product;